// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// npm i --package-lock-only

// const baseurl = 'http://25.102.122.150:8001/api/';

const baseurl = 'https://devtudrogueriavirtual.superat.com.co/api/';
// const baseurl = 'https://drogueriavirtual.superat.com.co/api/';

//PROD
const apiRed = 'https://api.redeca.unidrogas.com/'
//DEV
// const apiRed = 'https://redeca.mefid.com.co/'


export const environment = {
  production: false,

  app: {
    version: baseurl + 'appVersion',
  },

  /**
   * Rutas para el cliente que aún no inicia sesión
   */
  client: {
    LOGIN: baseurl + 'login',
    LOGOUT: baseurl + 'logout',
    FORGOT_PASSWORD: baseurl + 'forgetPass',
    USER_MODULES: baseurl + 'moduleValidator',
    VALIDATE_EMAIL_FROM_USER_CREATED: baseurl + 'validateEmail',
    VALIDATE_NEW_EMAIL_FROM_USER_EDITED: baseurl + 'validateNewEmail',
    UPDATE_PASSWORD_FIRST_TIME: baseurl + 'updateFirstPass',
  },
  /**
   * Módulo Perfil
   */
  profile: {
    USER_PROFILE: baseurl + 'userProfile',
    USER_CHANGE_PASSWORD: baseurl + 'newPassword',
    SET_USER_REST: baseurl + 'setUserRest',
    CONCEPTS_LIST: baseurl + 'conceptsList',
  },
  /**
   * Módulo de Órdenes
   */
  orders: {
    NEW_ORDERS_LIST: baseurl + 'newOrders',
    ORDERS_LIST: baseurl + 'orders',
    CANCEL_ORDER: baseurl + 'cancelOrder/',
    SET_ORDER_ADVISER: baseurl + 'setOrderAdviser/',
    UN_SET_ORDER_ADVISER: baseurl + 'unSetOrderAdviser/',
    CANCEL_REASONS_LIST: baseurl + 'canceledDetail',
    ORDERAMI: baseurl + 'newOrders',
    GET_BRANCH_OFFICE_NEARBY: baseurl + 'getBranchOfficeNearby',
    HEARTBEAT_ONLINE: baseurl + 'heartbeatOnline',
    sucursales: {
      BRANCH_OFFICES: baseurl + 'branchOffices',
      BRANCH_ORDERS: baseurl + 'branchOrders',
      // Información adicional de la orden: Sucursal donde se facturó, etc.
      ORDER_BRANCH_INFO: baseurl + 'newOrders',

    },
    GETDROPOPULAR: baseurl + 'getExternalOrders',
    GETDROPDETAIL: baseurl + 'getExternalOrdersDetail',
    SET_ORDER_PENDING: baseurl + 'setOrderPending/',
    SET_POSSIBLE_REVERSE: baseurl + 'setPossibleReverse/',
    PENDING_ORDERS: baseurl + 'getPendingOrders',
    ADD_ORDER_COMMENT: baseurl + 'addOrderComment/'

  },

  /**
  * Módulo de Turnos
  */

  turnos: {
    SHIFT_TYPES_LIST: baseurl + 'shift-types',
    CREATE_SHIFT_TYPE: baseurl + 'shift-types',
    SHIFT_TYPE_DETAIL: baseurl + 'shift-types',
    UPDATE_SHIFT_TYPE: baseurl + 'shift-types',
    DELETE_SHIFT_TYPE: baseurl + 'shift-types',
    ABSENCE_TYPES_LIST: baseurl + 'absence-types',
    CREATE_ABSENCE_TYPE: baseurl + 'absence-types',
    ABSENCE_TYPE_DETAIL: baseurl + 'absence-types',
    UPDATE_ABSENCE_TYPE: baseurl + 'absence-types',
    DELETE_ABSENCE_TYPE: baseurl + 'absence-types',
    ALL_MAX_ORDERS: baseurl + 'allMaxOrders',
    ALL_MAX_ORDERS_GET: baseurl + 'getMaxOrders'

  },
  /**
   * Módulo de Horarios
   */
  horarios: {
    MONTHLY_SCHEDULE: baseurl + 'shift-assignments/monthly',
    ASSIGN_SHIFT: baseurl + 'shift-assignments/assign',
    BULK_ASSIGN: baseurl + 'shift-assignments/bulk-assign',
    COPY_WEEK: baseurl + 'shift-assignments/copy-week',
    USER_ASSIGNMENTS: baseurl + 'shift-assignments/user',
    UPDATE_ASSIGNMENT_STATUS: baseurl + 'shift-assignments',
    DELETE_ASSIGNMENT: baseurl + 'shift-assignments',
    USER_STATS: baseurl + 'shift-assignments/user',
    OPERATORS_LIST: baseurl + 'operatorsList',
  },

  /**
   * Módulo de Observaciones
   */
  observaciones: {
    OBSERVACIONESLIST: baseurl + 'listOrderDetails',
    DETAILOBSERVACIONES: baseurl + 'showOrderDetails',
    UPDATEOBSERVATION: baseurl + 'updateObservation',
    OPERATOR: baseurl + 'operatorsList',
    STADISTICCITY: baseurl + 'averagePerCity',
    AGENTAVERAGE: baseurl + 'averagePerAgent',
    AGENTAVERAGEMONTH: baseurl + 'averagePerAgentMonth',
    AVERAGEPERCITY: baseurl + 'averagePerCityMonth',
    AVERAGEASSIGNAMENT: baseurl + 'averagePerAgentAssignmentMonth',
    AVERAGEORDERCITY: baseurl + 'averageOrdersPerCityMonth',
    GETOBSERVACIONESREASON: baseurl + 'observationReasonsList'
  },

  /**
   * Módulo de usuarios
   */
  user: {
    USERS_LIST: baseurl + 'users',
    CREATE_USER_POST: baseurl + 'users',
    USER_DETAILS: baseurl + 'users',
    RESET_ACCOUNT: baseurl + 'resetAcount/',
  },
  /**
   * Módulo de PQRS
   */
  pqrs: {
    PQRS_LIST: baseurl + 'PQRSList',
    PQRS_DETAILS: baseurl + 'pqrsClient',
    PQRS_STATE_LIST: baseurl + 'pqrsStateList',
    PQRS_CHANGE_STATUS: baseurl + 'PQRSChange',
    PQRS_RESPONSE: baseurl + 'responsePQRS',
  },
  /**
   * Ciudades
   */
  cities: {
    CITY_LIST: baseurl + 'cities',
    RUTACITYNEW: 'https://api.redeca.unidrogas.com/external/citylist/?disable_pagination=true'
  },
  /**
   * Roles
   */
  roles: {
    ROLES_LIST: baseurl + 'roles',
  },
  /**
   * Módulo Reportes
   * Estadísticas - Informes
   */
  statistics: {
    INFORME: baseurl + 'totalMoney',
    PRODUCTS_REPORT: baseurl + 'reportsByProducts',
    LABS_LIST: baseurl + 'labsList',
    // ordenes por estado
    ORDER_REPORTS: baseurl + 'ordersReports',
  },
  /**
   * Módulo Marketing
   */
  marketing: {
    PRODUCTS_LIST: baseurl + 'listProducts',
    MODIFY_PRODUCT: baseurl + 'modifyProduct',
    BULK_EXCEL_MODIFY_PRODUCT: baseurl + 'modifyProductTemplate',
    POST_UPLOAD_SEPARATA: baseurl + 'updateSeparata',
    GET_SEPARATA_OF_MONTH: baseurl + 'getSeparata',
  },

  metrics: {
    STATUSORDER: baseurl + 'statusOrdersMetrics',
    ORDERPERCENT: baseurl + 'onTimeInvoicedMetrics',
    ORDERPENDING: baseurl + 'orderListByTime',
    ORDERACTUAL: baseurl + 'orderListMetrics',
    CHART: baseurl + 'generalOrderMetricChart',
    ORDERMETRICS: baseurl + 'ordersMetrics',
    ORDERMODULETABLE: baseurl + 'operatorsInvoiced',
    METRICSTMJ: baseurl + 'metricsTMJData',
    PAYMENTDATA: baseurl + 'paymentDataReport',
    CHARTINGRESO: baseurl + 'paymentHistoryDataChart'
  },

  redeca: {
    POINTSTATUS: apiRed + 'external/puntosaludables',
    REGISTER_USER_PS: apiRed + 'external/preregistred'
  },

  repay: {
    REPAYMENT: baseurl + 'ordersToRepayment',
    DETAILREEMBOLSO: baseurl + 'ordersToRepayment',
    INICIARREEMBOLSO: baseurl + 'setRepaymentOrder',
    LISTADODEESTADOSREEMBOLSO: baseurl + 'repaymentStatusList',
    STATUSREPAY: baseurl + 'repaymentStatusFilter',
    LISTREASON: baseurl + 'repaymentReasonsList',
    CANCELORDER: baseurl + 'CancelTracking',
    ADDORDERTRACKING: baseurl + 'addFileInTracking',
    EXPORTAREXCELREEMBOLSO: baseurl + 'getRepaymentDataToExport'
  },

  puntosaludable: {
    PUNTOSALUDABLE: baseurl + 'ordersByGiftCards',
    PUNTOSDETAIL: baseurl + 'showOrderByGiftCards'
  },

  groups: {
    GROUPS_LIST: baseurl + 'groups',
    CREATE_GROUP: baseurl + 'groups',
    GROUP_DETAIL: baseurl + 'groups',
    ASSIGN_USERS: baseurl + 'groups',
    ASSIGN_PRIORITIES: baseurl + 'groups'
  },

  /**
 * Configuraciones Generales del Sistema
 */
  settings: {
    GENERAL_SETTINGS: baseurl + 'generalSettings',
  },



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
